Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-lazy-html-area');

    var $configuration, configurations = [],
        currentitemid = 0;
    var model = null;
    var wrappers = $wrappers;

    if ($wrappers.length < 1)
        return;

    if (LhApp.Context.Item.Id !== undefined && LhApp.Context.Item.Id > 0)
        currentitemid = LhApp.Context.Item.Id;

    for (var i = 0; i < wrappers.length; i++) {
        var wrpr = wrappers[i];

        $configuration = $('.configuration', wrpr);

        configurations.push({
            configCode: $configuration.data("code"),
            templateCode: $configuration.data("template"),
            entityCode: $configuration.data("entity"),
            itemId: currentitemid,
            nodeId: $configuration.data("node-id"),
            nodePath: $configuration.data("node-path"),
            htmlTemplate: $configuration.data("html")
        });

        $configuration.remove();
    }

    $.each($wrappers, function (i, wrpr) {
        var $this = $(wrpr);

        wrpr.loading = function loading(loading) {
            if (loading) {
                $this.addClass('x-loading');
            } else {
                $this.removeClass('x-loading');
            };
        };

        wrpr.update = function update() {
            wrpr.loading(true);

            var html = Vendd.Handlebars.parse(configurations[0].htmlTemplate, model);
            wrpr.bind(html);

            Vendd.MessageBus.publish(wrpr, new Vendd.Widget.Messages.BindControl($(wrpr)));
            wrpr.loading(false);
        };

        wrpr.bind = function bind(html) {
            $this.html(html);

            if (configurations[0].htmlTemplate == "bannerList_A")
                var bannerSlider = new Swiper(".promo-container-one", {
                    slidesPerView: 1,
                    autoHeight: true,
                    breakpoints: {
                        769: { slidesPerView: 3 },
                        480: { slidesPerView: 2 }
                    },
                });
        };
    });

    Vendd.MessageBus.subscribe(Vendd.LazyHtmlArea.Messages.LazyHtmlAreaSuccess, wrappers.get(0), function (envelope) {

        if (envelope.message.data.sender !== wrappers.get(0)) return;

        var innerWrapper = wrappers.get(0);
        var config = configurations[0];

        if (innerWrapper) {
            model = envelope.message.data.model;
            innerWrapper.update();

            removeConfiguration(innerWrapper, config);
        }
        if (wrappers.length < 1 || configurations.length < 1) return;

        Vendd.MessageBus.publishAsync(wrappers.get(0), new Vendd.LazyHtmlArea.Messages.GetLazyHtmlArea(configurations[0]));
    });

    function removeConfiguration(innerwrapper, config) {

        if (wrappers.length > 0) {
            wrappers = wrappers.slice(1);
        }

        if (configurations.length > 0) {
            var configIndex = configurations.indexOf(config);
            configurations.splice(configIndex, 1);
        }
    };

    //keep last in component's code
    (function () {
        var defaultCallExecuted;
        function defaultCall() {
            if (Vendd.User.SessionState && !defaultCallExecuted) {
                defaultCallExecuted = true;
                Vendd.MessageBus.publishAsync(wrappers.get(0), new Vendd.LazyHtmlArea.Messages.GetLazyHtmlArea(configurations[0]));
            }
        }
        defaultCall();
        Vendd.MessageBus.subscribe(Vendd.User.Messages.GetSessionStateSuccess, wrappers.get(0), function (envelope) {
            defaultCall();
        });
    })();

});